import api from "./api";

function getVisitorId() {
  let v = localStorage.getItem("fh_visitor_id");
  if (!v) {
    v = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(36).slice(2);
    localStorage.setItem("fh_visitor_id", v);
  }
  return v;
}

function getSessionId() {
  let s = sessionStorage.getItem("fh_session_id");
  if (!s) {
    s = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(36).slice(2);
    sessionStorage.setItem("fh_session_id", s);
  }
  return s;
}

// Fire-and-forget event tracking. Never blocks or throws.
export function trackEvent(type, payload = {}) {
  try {
    const firstThisSession = !sessionStorage.getItem("fh_ref_sent");
    const referrer = firstThisSession ? (document.referrer || "") : "";
    if (firstThisSession) sessionStorage.setItem("fh_ref_sent", "1");

    const body = {
      events: [{ type, ...payload }],
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
      referrer,
    };

    const url = `${process.env.REACT_APP_BACKEND_URL}/api/track`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([JSON.stringify(body)], { type: "application/json" }));
    } else {
      api.post("/track", body).catch(() => {});
    }
  } catch {
    /* analytics must never break the app */
  }
}
